import { useEffect, useState } from "react";
import Sidebar from "components/Common/SideBar/SideBar";
import CenterPointHeader from "components/Common/Header/Header";
import Grid from "@mui/material/Grid";
import classes from "./CenterPointLayout.module.css";
import Default from "components/Common/Default/Default";
import SearchEmployee from "components/CenterPoint/SearchEmployee/SearchEmployee";
import { useLocation, useNavigate } from "react-router-dom";
import BulkUpload from "components/CenterPoint/BulkUpload/BulkUpload";
import AuditTrail from "components/CenterPoint/AuditTrail/AuditTrail";
import AddEmployee from "components/CenterPoint/AddNonHRMSEmployee/AddNonHRMSEmployee";
import { useAuth } from "context/AuthContext";

const CenterPointLayout = () => {
  const { hasPermission, isLoaded } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!isLoaded) return;
    if (!hasPermission("CP_Group")) navigate("/");
  }, [hasPermission, isLoaded, navigate]);

  useEffect(() => {
    if (location.pathname === "/centerpoint") setIndex(() => 0);

    if (location.pathname === "/centerpoint/searchEmployee") setIndex(() => 1);

    if (location.pathname === "/centerpoint/addEmployee") setIndex(2);

    if (location.pathname === "/centerpoint/bulkUpload") setIndex(3);

    if (location.pathname === "/centerpoint/auditTrails") setIndex(5);
  }, [location.pathname]);

  return (
    <Grid container spacing={2} className={classes.centerPointBody}>
      <Grid item xs={0.75} className={classes.grid}>
        <Sidebar index={index} type="centerpoint" />
      </Grid>
      <Grid item xs={11.25} className={classes.grid}>
        <CenterPointHeader
          title="CenterPoint"
          logoURL="/centerpoint"
          version="new"
        />
        <div className={classes.content}>
          {index === 0 && <Default />}
          {index === 1 && <SearchEmployee />}
          {index === 2 && <AddEmployee />}
          {index === 3 && <BulkUpload />}
          {index === 5 && <AuditTrail />}
        </div>
      </Grid>
    </Grid>
  );
};

export default CenterPointLayout;
